
import { CityLanguage } from '@/context/languages/languageData';

// Mapeo de países a idiomas principales - Expandido para todos los países
export const countryLanguageMap: Record<string, CityLanguage> = {
  // Europa
  'ES': 'es', // España
  'FR': 'fr', // Francia
  'DE': 'de', // Alemania
  'IT': 'it', // Italia
  'PT': 'pt', // Portugal
  'GB': 'en', // Reino Unido
  'IE': 'en', // Irlanda
  'NL': 'nl', // Países Bajos
  'BE': 'fr', // Bélgica
  'AT': 'de', // Austria
  'CH': 'de', // Suiza
  'PL': 'pl', // Polonia
  'CZ': 'cs', // República Checa
  'HU': 'hu', // Hungría
  'RO': 'ro', // Rumania
  'BG': 'bg', // Bulgaria
  'HR': 'hr', // Croacia
  'SK': 'sk', // Eslovaquia
  'SI': 'sl', // Eslovenia
  'LT': 'lt', // Lituania
  'LV': 'lv', // Letonia
  'EE': 'et', // Estonia
  'FI': 'fi', // Finlandia
  'SE': 'sv', // Suecia
  'NO': 'no', // Noruega
  'DK': 'da', // Dinamarca
  'IS': 'is', // Islandia
  'GR': 'el', // Grecia
  'CY': 'en', // Chipre
  'MT': 'en', // Malta
  'LU': 'fr', // Luxemburgo
  'MC': 'fr', // Mónaco
  'AD': 'es', // Andorra
  'SM': 'it', // San Marino
  'VA': 'it', // Vaticano
  'LI': 'de', // Liechtenstein
  'RS': 'en', // Serbia
  'BA': 'en', // Bosnia y Herzegovina
  'ME': 'en', // Montenegro
  'MK': 'en', // Macedonia del Norte
  'AL': 'en', // Albania
  'XK': 'en', // Kosovo
  'MD': 'ro', // Moldova - Romanian
  'UA': 'uk', // Ucrania
  'BY': 'ru', // Belarus - Russian
  'RU': 'ru', // Russia - Russian

  // América del Norte
  'US': 'en', // Estados Unidos
  'CA': 'en', // Canadá
  'MX': 'es', // México
  'GL': 'en', // Groenlandia
  'PM': 'fr', // San Pedro y Miquelón

  // América Central y Caribe
  'GT': 'es', // Guatemala
  'BZ': 'en', // Belice
  'HN': 'es', // Honduras
  'SV': 'es', // El Salvador
  'NI': 'es', // Nicaragua
  'CR': 'es', // Costa Rica
  'PA': 'es', // Panamá
  'CU': 'es', // Cuba
  'DO': 'es', // República Dominicana
  'HT': 'fr', // Haití
  'JM': 'en', // Jamaica
  'TT': 'en', // Trinidad y Tobago
  'BB': 'en', // Barbados
  'BS': 'en', // Bahamas
  'AG': 'en', // Antigua y Barbuda
  'DM': 'en', // Dominica
  'GD': 'en', // Granada
  'KN': 'en', // San Cristóbal y Nieves
  'LC': 'en', // Santa Lucía
  'VC': 'en', // San Vicente y las Granadinas
  'PR': 'es', // Puerto Rico
  'VI': 'en', // Islas Vírgenes de EE.UU.
  'VG': 'en', // Islas Vírgenes Británicas
  'AI': 'en', // Anguila
  'MS': 'en', // Montserrat
  'TC': 'en', // Islas Turcas y Caicos
  'KY': 'en', // Islas Caimán
  'BM': 'en', // Bermudas

  // América del Sur
  'AR': 'es', // Argentina
  'BR': 'pt', // Brasil
  'CL': 'es', // Chile
  'CO': 'es', // Colombia
  'PE': 'es', // Perú
  'VE': 'es', // Venezuela
  'EC': 'es', // Ecuador
  'BO': 'es', // Bolivia
  'PY': 'es', // Paraguay
  'UY': 'es', // Uruguay
  'GY': 'en', // Guyana
  'SR': 'en', // Surinam
  'GF': 'fr', // Guayana Francesa
  'FK': 'en', // Islas Malvinas

  // Asia Oriental
  'CN': 'zh', // China
  'JP': 'ja', // Japón
  'KR': 'ko', // Corea del Sur
  'KP': 'ko', // Corea del Norte
  'TW': 'zh', // Taiwán
  'HK': 'zh', // Hong Kong
  'MO': 'zh', // Macao
  'MN': 'en', // Mongolia

  // Asia Sudoriental
  'IN': 'hi', // India
  'ID': 'id', // Indonesia
  'TH': 'th', // Tailandia
  'VN': 'vi', // Vietnam
  'PH': 'tl', // Filipinas
  'MY': 'ms', // Malasia
  'SG': 'en', // Singapur
  'KH': 'en', // Camboya
  'LA': 'en', // Laos
  'MM': 'en', // Myanmar
  'BN': 'ms', // Brunéi
  'TL': 'en', // Timor Oriental
  'BD': 'bn', // Bangladés
  'PK': 'ur', // Pakistán
  'AF': 'en', // Afganistán
  'LK': 'en', // Sri Lanka
  'MV': 'en', // Maldivas
  'NP': 'en', // Nepal
  'BT': 'en', // Bután

  // Asia Occidental (Oriente Medio)
  'IR': 'fa', // Irán
  'IQ': 'ar', // Irak
  'SY': 'ar', // Siria
  'LB': 'ar', // Líbano
  'JO': 'ar', // Jordania
  'IL': 'he', // Israel
  'PS': 'ar', // Palestina
  'SA': 'ar', // Arabia Saudí
  'AE': 'ar', // Emiratos Árabes Unidos
  'QA': 'ar', // Catar
  'BH': 'ar', // Baréin
  'KW': 'ar', // Kuwait
  'OM': 'ar', // Omán
  'YE': 'ar', // Yemen
  'TR': 'tr', // Turquía
  'AM': 'ru', // Armenia - Russian
  'AZ': 'ru', // Azerbaijan - Russian
  'GE': 'en', // Georgia

  // Asia Central
  'KZ': 'ru', // Kazajstán - Russian
  'KG': 'ru', // Kirguistán - Russian
  'TJ': 'ru', // Tayikistán - Russian
  'TM': 'ru', // Turkmenistán - Russian
  'UZ': 'ru', // Uzbekistán - Russian

  // África del Norte
  'EG': 'en', // Egipto
  'LY': 'en', // Libia
  'TN': 'fr', // Túnez
  'DZ': 'fr', // Argelia
  'MA': 'fr', // Marruecos
  'SD': 'en', // Sudán
  'SS': 'en', // Sudán del Sur

  // África Occidental
  'NG': 'en', // Nigeria
  'GH': 'en', // Ghana
  'CI': 'fr', // Costa de Marfil
  'SN': 'fr', // Senegal
  'ML': 'fr', // Malí
  'BF': 'fr', // Burkina Faso
  'NE': 'fr', // Níger
  'GN': 'fr', // Guinea
  'SL': 'en', // Sierra Leona
  'LR': 'en', // Liberia
  'TG': 'fr', // Togo
  'BJ': 'fr', // Benín
  'GM': 'en', // Gambia
  'GW': 'pt', // Guinea-Bisáu
  'CV': 'pt', // Cabo Verde
  'MR': 'fr', // Mauritania

  // África Oriental
  'ET': 'en', // Etiopía
  'KE': 'sw', // Kenia
  'UG': 'en', // Uganda
  'TZ': 'sw', // Tanzania
  'RW': 'fr', // Ruanda
  'BI': 'fr', // Burundi
  'SO': 'en', // Somalia
  'DJ': 'fr', // Yibuti
  'ER': 'en', // Eritrea
  'SC': 'en', // Seychelles
  'MU': 'en', // Mauricio
  'KM': 'fr', // Comoras
  'MG': 'fr', // Madagascar

  // África Central
  'CD': 'fr', // República Democrática del Congo
  'CG': 'fr', // República del Congo
  'CF': 'fr', // República Centroafricana
  'CM': 'fr', // Camerún
  'TD': 'fr', // Chad
  'GA': 'fr', // Gabón
  'GQ': 'es', // Guinea Ecuatorial
  'ST': 'pt', // Santo Tomé y Príncipe
  'AO': 'pt', // Angola

  // África Austral
  'ZA': 'en', // Sudáfrica
  'ZW': 'en', // Zimbabue
  'BW': 'en', // Botsuana
  'LS': 'en', // Lesoto
  'SZ': 'en', // Esuatini
  'NA': 'en', // Namibia
  'ZM': 'en', // Zambia
  'MW': 'en', // Malawi
  'MZ': 'pt', // Mozambique

  // Oceanía
  'AU': 'en', // Australia
  'NZ': 'en', // Nueva Zelanda
  'PG': 'en', // Papúa Nueva Guinea
  'FJ': 'en', // Fiyi
  'SB': 'en', // Islas Salomón
  'VU': 'en', // Vanuatu
  'NC': 'fr', // Nueva Caledonia
  'PF': 'fr', // Polinesia Francesa
  'WF': 'fr', // Wallis y Futuna
  'TO': 'en', // Tonga
  'WS': 'en', // Samoa
  'KI': 'en', // Kiribati
  'TV': 'en', // Tuvalu
  'NR': 'en', // Nauru
  'PW': 'en', // Palaos
  'MH': 'en', // Islas Marshall
  'FM': 'en', // Estados Federados de Micronesia
  'AS': 'en', // Samoa Americana
  'GU': 'en', // Guam
  'MP': 'en', // Islas Marianas del Norte
  'CK': 'en', // Islas Cook
  'NU': 'en', // Niue
  'TK': 'en', // Tokelau
  'PN': 'en' // Islas Pitcairn
};
